/**
 * Shared Recharts theme (#397). Series colors come from the tokens so charts follow
 * light/dark mode; status colors are never used as series.
 *
 * Usage: <Bar fill={seriesColor(0)} />, <CartesianGrid {...chartGrid} />,
 * <XAxis {...chartAxis} />, <Tooltip {...chartTooltip} />
 */
const cssColor = (name: string) => `rgb(var(--color-${name}))`

export const SERIES_COLORS = [cssColor('series-1'), cssColor('series-2'), cssColor('series-3')]

export function seriesColor(index: number): string {
  return SERIES_COLORS[index % SERIES_COLORS.length]
}

export const chartGrid = {
  stroke: cssColor('line'),
  strokeDasharray: '0',
  vertical: false,
}

export const chartAxis = {
  stroke: cssColor('line-strong'),
  tick: { fill: cssColor('muted'), fontSize: 12 },
  tickLine: false,
  axisLine: { stroke: cssColor('line-strong') },
}

export const chartTooltip = {
  cursor: { fill: cssColor('surface-raised') },
  contentStyle: {
    background: cssColor('surface'),
    border: `1px solid ${cssColor('line')}`,
    borderRadius: 8,
    color: cssColor('ink'),
    fontSize: 13,
    boxShadow: '0 8px 24px -4px rgb(0 0 0 / 0.12)',
  },
  labelStyle: { color: cssColor('ink'), fontWeight: 600 },
  itemStyle: { color: cssColor('ink-secondary') },
}
